(function($) {

  $(window).on('load', function() {

    var isMobile = $(window).width() <= 749;

    // ─── Product Image Slider ─────────────────────────────────────────────

    if (isMobile) {
      $('.product-image-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        infinite: true,
        swipe: true,
        dots: false
      });
    } else {
      $('.product-image-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        infinite: true,
        asNavFor: '.product-image-slider-nav'
      });

      $('.product-image-slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        asNavFor: '.product-image-slider',
        dots: false,
        infinite: true,
        arrows: false,
        focusOnSelect: true
      });
    }

    // ─── Mobile Progress Bar ──────────────────────────────────────────────

   var totalSlides = $('.product-image-slider').slick('getSlick').slideCount;

    var segmentsHtml = '<div class="slider-segments">';
    for (var s = 0; s < totalSlides; s++) {
    segmentsHtml += '<button class="slider-segment' + (s === 0 ? ' slider-segment--active' : '') + '" data-slide="' + s + '" aria-label="Go to image ' + (s + 1) + '"></button>';
    }
    segmentsHtml += '</div>';
    $('.product-image-slider').after(segmentsHtml);

    // Click to navigate
    $(document).on('click', '.slider-segment', function() {
    var index = $(this).data('slide');
    $('.product-image-slider').slick('slickGoTo', index);
    });

    // Update on slide change
    $('.product-image-slider').on('afterChange', function(event, slick, currentSlide) {
     $('.slider-segment').removeClass('slider-segment--active');
    $('.slider-segment').eq(currentSlide).addClass('slider-segment--active');
    });

// ─── Variant Image Sync ───────────────────────────────────────────────

var productData = null;
var productJsonEl = document.getElementById('product-json');
if (productJsonEl) {
  try { productData = JSON.parse(productJsonEl.textContent); } catch(e) {}
}

if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function(event) {
    if (!productData) return;

    var selectedOptionValueIds = event.data.selectedOptionValues;
    if (!selectedOptionValueIds || !selectedOptionValueIds.length) return;

    // Map IDs to option value text via DOM
    var selectedValues = selectedOptionValueIds.map(function(id) {
      var input = document.querySelector('[data-option-value-id="' + id + '"]');
      return input ? input.value : null;
    }).filter(Boolean);

    if (!selectedValues.length) return;

    // Find matching variant by option values
    var matchedVariant = productData.variants.find(function(v) {
      return selectedValues.every(function(val) {
        return v.options.indexOf(val) > -1;
      });
    });

    if (!matchedVariant || !matchedVariant.featured_media) return;

    var targetMediaId = String(matchedVariant.featured_media.id);

    // Find slide index
    var slideIndex = -1;
    document.querySelectorAll('.product-image-slider-wrapper').forEach(function(el, i) {
      if (el.dataset.mediaId === targetMediaId) slideIndex = i;
    });

    if (slideIndex === -1) return;

    // Always go to slide on main slider
    $('.product-image-slider').slick('slickGoTo', slideIndex);

    // Also sync nav on desktop if initialized
    if ($('.product-image-slider-nav').hasClass('slick-initialized')) {
      $('.product-image-slider-nav').slick('slickGoTo', slideIndex);
    }
  });
}


    // ─── Recipe Image Slider ──────────────────────────────────────────────

    $('.recipe-image-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: true,
      asNavFor: '.recipe-image-slider-nav'
    });

    $('.recipe-image-slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.recipe-image-slider',
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: '<button class="button-slider slide-arrow prev-arrow">❯</button>',
      nextArrow: '<button class="button-slider slide-arrow next-arrow">❯</button>',
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 540,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    // ─── Accordion ────────────────────────────────────────────────────────

    var acc = document.getElementsByClassName("accordion2");

    for (var i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }

  });

})(jQuery);
